import {
  TextInput,
  NumberInput,
  ReferenceInput,
  AutocompleteInput,
  DateInput,
  required,
  Labeled,
  SelectArrayInput,
  ReferenceArrayInput,
  FormDataConsumer,
  ReferenceField,
  TextField,
  NumberField,
  useRecordContext,
} from "react-admin";
import { Stack } from "@mui/material";

import InvoiceIntervalSelectInput from "./InvoiceIntervalSelectInput";
import BillingMethodSelectInput from "./BillingMethodSelectInput";
import FormContainer from "../common/FormContainer";

const ServiceBookingFields = () => {
  const record = useRecordContext();

  return (
    <>
      <FormContainer>
        <ReferenceInput
          source="customerId"
          reference="Customer"
          sort={{ field: "name", order: "ASC" }}
          filterToQuery={(searchText: any) => ({
            q: searchText,
          })}
        >
          <AutocompleteInput
            optionText="name"
            fullWidth
            validate={required()}
          />
        </ReferenceInput>
      </FormContainer>

      <FormContainer maxWidth="sm">
        <NumberInput source="amount" validate={required()} fullWidth />
      </FormContainer>

      <FormContainer>
        <ReferenceInput
          source="serviceTemplateId"
          reference="ServiceTemplate"
          sort={{ field: "name", order: "ASC" }}
          filterToQuery={(searchText: any) => ({
            q: searchText,
          })}
        >
          <AutocompleteInput
            optionText="name"
            fullWidth
            validate={required()}
          />
        </ReferenceInput>
      </FormContainer>

      <FormContainer maxWidth="lg">
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <ReferenceField
              source="serviceTemplateId"
              record={formData}
              reference="ServiceTemplate"
            >
              <Stack direction="row" gap={2} marginBottom={4}>
                <Labeled>
                  <NumberField
                    source="monthlyCost"
                    label="mtl. Preis"
                    options={{ style: "currency", currency: "EUR" }}
                  />
                </Labeled>
                <Labeled>
                  <TextField
                    source="invoiceLineText"
                    label="Rechnungspositionstext"
                  />
                </Labeled>
              </Stack>
            </ReferenceField>
          )}
        </FormDataConsumer>
      </FormContainer>

      <FormContainer>
        <NumberInput source="discountPercent" fullWidth />
      </FormContainer>

      <FormContainer maxWidth="xl">
        <TextInput
          source="additionalInvoiceLineText"
          helperText="wird unter dem Rechnungspositionstext der Vorlage angefügt"
          multiline
          defaultValue=""
          parse={(v: any) => String(v)}
          fullWidth
        />
      </FormContainer>

      <FormContainer>
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <ReferenceArrayInput
              source="domainIds"
              reference="Domain"
              sort={{ field: "unicodeName", order: "ASC" }}
              filter={{
                customerId: formData.customerId,
                withoutServiceBooking: true,
                serviceBookingId: record?.id,
              }}
              filterToQuery={(searchText: any) => ({
                q: searchText,
              })}
              {...rest}
            >
              <SelectArrayInput
                optionText="unicodeName"
                fullWidth
                label="Domains"
              />
            </ReferenceArrayInput>
          )}
        </FormDataConsumer>
      </FormContainer>

      <FormContainer maxWidth="xl">
        <TextInput
          multiline
          source="comment"
          defaultValue=""
          parse={(v: any) => String(v)}
          fullWidth
        />
      </FormContainer>

      <FormContainer maxWidth="sm">
        <DateInput source="bookedFrom" validate={required()} fullWidth />
        <DateInput source="canceledOn" fullWidth />
        <DateInput source="invoicedUntil" fullWidth />
      </FormContainer>

      <FormContainer>
        <InvoiceIntervalSelectInput
          source="invoiceInterval"
          validate={required()}
          fullWidth
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <>
              {formData.invoiceInterval !== "None" && (
                <BillingMethodSelectInput
                  source="billingMethod"
                  validate={required()}
                  fullWidth
                />
              )}
              {formData.billingMethod === "Sepa" && (
                <TextInput
                  source="sepaBilling.mandateReference"
                  defaultValue=""
                  fullWidth
                />
              )}
            </>
          )}
        </FormDataConsumer>
      </FormContainer>
    </>
  );
};

export default ServiceBookingFields;
